import React from 'react';
import styled from 'styled-components';
import uuid from 'uuid';
import i18n from '../../config/i18n';
import config from '../../config/configureEnv';

const H1 = styled.h1`
  color: #3C4F62;
  font-weight: 500;
  font-size: 3.2em;
  text-align: center;
  margin-top: 70px;
`;

const UpdatedText = styled.p`
  color: #B5C7D9;
  text-align: center;
  margin-top: 30px;
  margin-bottom: 60px;
`;

const H3 = styled.h3`
  font-size: 1.8em;
  color: #748495;
  font-weight: 700;
  text-align: center;
  margin-top: 4em;
  margin-bottom: 2em;
`;

const P = styled.p`
  color: #73767c;
  line-height: 1.7;
  font-size: 16px;
  font-family: "Open Sans", Arial, sans-serif;
  text-align: justify;
`;


/**
 * TODO:
 *  Make each question a section so that users can find the question which they
 *  want to learn about quickly when being directed to this page.
 */
const FAQ = () => {
  const translations = {
    iHealthCareClouds: i18n.t('iHealthCareClouds'),
    GuruSyncQTM: i18n.t('GuruSyncQTM'),
  };
  const iHealthCareEmail = i18n.t('iHealthCareEmail');
  const iHealthCareNoReplyEmail = i18n.t('iHealthCareNoReplyEmail');
  const { bocaDashboardUrl } = config;
  const replacements = {
    iHealthCareEmail: () => (
      <a
        href={`mailto:${iHealthCareEmail}`}
        key={uuid()}
      >
        {iHealthCareEmail}
      </a>
    ),
    iHealthCareNoReplyEmail: () => (
      <a
        href={`mailto:${iHealthCareNoReplyEmail}`}
        key={uuid()}
      >
        {iHealthCareNoReplyEmail}
      </a>
    ),
    landingPageUrl: () => (
      <a
        href={bocaDashboardUrl}
        key={uuid()}
      >
        {bocaDashboardUrl}
      </a>
    ),
    subscriptionPage: () => (
      <a
        href="/subscription"
        key={uuid()}
      >
        {i18n.t(['FAQ', 'subscriptionPage'])}
      </a>
    ),
    '\\n': () => <br key={uuid()} />,
  };

  // Replace the specified key word with a component.
  const replace = (string, option) => {
    const result = [];
    const splitStrings = string.split(Object.keys(option)[0]);

    for (let i = 0; i + 1 < splitStrings.length; i += 1) {
      result.push(splitStrings[i]);
      result.push(Object.values(option)[0]());
    }

    if (splitStrings.length) {
      result.push(splitStrings[splitStrings.length - 1]);
    }

    return result;
  };

  // Replace specified key words with multiple components.
  const replaceMultiple = (string, options) => {
    let currentResult = [string];
    let nextResult = [];

    Object.keys(options).forEach((key) => {
      nextResult = [];
      currentResult.forEach((element) => {
        if (typeof element === 'string') {
          nextResult.push(...replace(element, { [key]: options[key] }));
        } else {
          nextResult.push(element);
        }
      });
      currentResult = nextResult;
    });

    return currentResult;
  };

  /** @param {Array, String} paragraphs */
  const injectComponents = (paragraphs) => {
    if (Array.isArray(paragraphs)) {
      return paragraphs.map(paragraph => replaceMultiple(paragraph, replacements));
    }
    return replaceMultiple(paragraphs, replacements);
  };

  const generateContents = () => {
    const contents = i18n.t(['FAQ', 'contents']);
    return contents.map((value, index) => (
      <div key={uuid()}>
        <H3>{i18n.t(['FAQ', 'contents', index, 'header'], translations)}</H3>
        <P>
          {injectComponents(i18n.t(['FAQ', 'contents', index, 'paragraph'], translations))}
        </P>
      </div>
    ));
  };

  return (
    <div
      className="PrivacyPolicy"
      style={{ paddingBottom: 100 }}
    >
      <H1>{i18n.t(['FAQ', 'title'])}</H1>
      <UpdatedText>{i18n.t(['FAQ', 'updatedDate'])}</UpdatedText>
      {generateContents()}
    </div>
  );
};

FAQ.propTypes = {};
FAQ.defaultProps = {};

export default FAQ;



// WEBPACK FOOTER //
// ./src/components/static/FAQ.js